module.exports = __webpack_public_path__ + "img/flot-fyr-paa-snap-1.a62e1900.png";